import { getEnvVariable } from './getEnvVariable';

export const isProd = getEnvVariable('CI_ENVIRONMENT_NAME') === 'production';
